<div class="row">
    <div class="col-12 form-group" *ngFor="let item of list; index as index">
        <div class="row">
            <!-- firstOperator -->
            <div class="col-5 no-padding-right first-fee">
                <label>{{unit}} </label>
                <div class="group__form">
                    <select class="form-control" id="header-soflow" name="" [disabled]="true"
                        [(ngModel)]="item.beginOperatorCode">
                        <option *ngFor="let operator of beginOperators" [value]="operator.code">
                            <label style="font-weight:600">
                                {{operator.code}}
                            </label>
                        </option>
                    </select>
                    <div class="input-group">
                        <input-number class="w-100" [disabled]="index > 0" [(amount)]="item.beginVolume">
                        </input-number>
                    </div>
                </div>
                <span class="error-text"
                    *ngIf="isSaved && item.errors?.beginVolume">
                    Vui lòng nhập giá trị
                </span>
            </div>
            <div class="col-3 no-padding-right second-fee">
                <div class="row" >
                    <div class="col-12">
                        <label>{{unit}} </label>
                    </div>
                    <div class="col-12">
                        <!-- second Operator -->
                        <div class="group__form" >
                            <select class="select-input form-control" [(ngModel)]="item.endOperatorCode"
                                (ngModelChange)="changeOperator(index)" [disabled]="index === list.length - 1">
                                <option *ngFor="let operator of endOperators" [value]="operator.code">
                                    <label style="font-weight:600">
                                        {{operator.code}}
                                    </label>
                                </option>
                            </select>
                            <!-- end Volume -->
                            <input-number class="w-100" [(amount)]="item.endVolume" (result)="changeValue(index)" [disabled]="index === list.length - 1" >
                            </input-number>
                        </div>
                    </div>

                    <!-- Error -->
                    <div class="col-12">
                        <div class="d-flex flex-column">
                            <span class="error-text" *ngIf="isSaved && item.errors?.endVolume">
                                Vui lòng nhập giá trị
                            </span>
                            <span class="error-text"
                                *ngIf="isSaved && item.errors?.small">
                                Giá trị nhỏ hơn giá trị trước
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Lasted Value - FEE -->
            <div class="col-4 percent-fee">
                <div class="row">
                    <div class="col-12">
                        <label>{{unitValue}}</label>
                    </div>
                    <div class="col-6">
                        <div class="input-group d-flex flex-row">
                            <input-number class="w-100" [isDecimal]="true" [(amount)]="item.keyValue">
                            </input-number>
                        </div>
                        <span class="error-text"
                            *ngIf="isSaved && !(item.keyValue || item.keyValue === 0)">
                            Vui lòng nhập
                        </span>
                    </div>
                    <div class="col-3">
                        <div class="remove-fee" *ngIf="!isViewed && index > 0 && index < list.length - 1">
                            <button class="btn" (click)="removeValueRange(index)">
                                <img src="../../../../../assets/images/icons/ic-minus.svg" alt="">
                            </button>
                        </div>
                        <div class="remove-fee" *ngIf="!isViewed && index === list.length - 1">
                            <button class="btn" (click)="addValueRange()">
                                <img src="../../../../../assets/images/icons/plus.svg" alt="">
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>